import { useLocation } from "react-router-dom";
import React from "react";

/**
 * This component merges the query params that are after the # sign
 * and thoe that are before.
 */
export function useUrlQuery() {
  const location = useLocation();

  return React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
}
